// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__mqLnm","name":"ConsentHeader_name__1DkbB","birthday":"ConsentHeader_birthday__1cxZw","skeleton":"ConsentHeader_skeleton__GBxZP"};